<div class="modal-overlay" *ngIf="employee">
    <div class="modal-container">
        <div class="modal-header">
            <h2>Krankmeldungen - {{ employee.name }}</h2>
            <button class="close-button" aria-label="Schließen" (click)="onClose()">×</button>
        </div>

        <div class="modal-content">
            <div class="employee-info">
                <p><strong>Mitarbeiternummer:</strong> {{ employee.datevEmployeeNumber }}</p>
                <p><strong>E-Mail:</strong> {{ employee.email }}</p>
            </div>

            <div class="loading-spinner" *ngIf="loading()">
                Lade Krankmeldungen...
            </div>

            <div class="error-message" *ngIf="error()">
                {{ error() }}
            </div>

            <div class="sick-leaves-section" *ngIf="!loading() && !error()">
                <h3>Krankmeldungen ({{ sickLeaves().length }})</h3>

                <div class="auth-required-message" *ngIf="!datevAuthService.getAuthStatus()()">
                    Für Einreichen/Abholen/Stornieren ist eine DATEV-Authentifizierung erforderlich.
                    <button type="button" class="datev-login-button" (click)="datevAuthService.loginDatev()">
                        Bei DATEV anmelden
                    </button>
                </div>

                <div class="table-container" *ngIf="sickLeaves().length > 0">
                    <table>
                        <thead>
                        <tr>
                            <th>Beginn AU</th>
                            <th>Ende AU</th>
                            <th>Status</th>
                            <th>Fehlergrund</th>
                            <th>Aktionen</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let leave of sickLeaves()"
                            [class.cancelled]="isCancelled(leave.status)"
                            [class.error-status]="isError(leave.status)">
                            <td>{{ leave.von | date: 'dd.MM.yyyy' }}</td>
                            <td>{{ leave.bis | date: 'dd.MM.yyyy' }}</td>
                            <app-eau-row-actions [leave]="leave" (actionCompleted)="refreshEmployeeSickLeavesSilently()"></app-eau-row-actions>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="no-data" *ngIf="sickLeaves().length === 0">
                    Keine Krankmeldungen für diesen Mitarbeiter vorhanden.
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button class="close-button-bottom" (click)="onClose()" id="employeeListEAUCloseButton">Schließen</button>
        </div>
    </div>
</div>
